import { FC } from 'react';
import isEmpty from 'lodash/isEmpty';

import { useBrandAffinityTranslation } from 'modules/domains/brandAffinity';

import { BrandAffinityXAI, useBrandAffinityXAIContext } from 'modules/ai/XAI/audienceUserProfile';
import { AffinityScoreData } from './AffinityScoreData';
import { AffinityScoreHistory } from './AffinityScoreHistory';
import { ScoreSkeleton } from './ScoreSkeleton';
import { getScoreUIDataByLevel, getRelativeToMonthSpan, transformScoreHistory } from '../utils';
import { Card, ContentDivider } from '../Styles';
import { ScoreDescription } from './ScoreCard.styles';

export const ScoreHistory: FC = () => {
  const { t } = useBrandAffinityTranslation();
  const { affinityData, isError, isLoading } = useBrandAffinityXAIContext();
  if (isLoading) {
    return <ScoreSkeleton />;
  }

  if (isError) {
    return (
      <Card data-test="brand-affinity-xai-score-error">
        <AffinityScoreData isCurrentScore isError />
      </Card>
    );
  }

  const { computedDate, label, history } = affinityData as BrandAffinityXAI;
  const { description } = getScoreUIDataByLevel(label);
  const hasNoHistory = isEmpty(history);
  const scoreHistory = transformScoreHistory(history);
  return (
    <Card data-test="brand-affinity-xai-score">
      <AffinityScoreData
        isCurrentScore
        label={label}
        relativeDate={getRelativeToMonthSpan(computedDate)}
      />
      <ScoreDescription>{t(description)}</ScoreDescription>
      {hasNoHistory ? null : (
        <>
          <ContentDivider />
          <AffinityScoreHistory scores={scoreHistory} />
        </>
      )}
    </Card>
  );
};
